<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$router.push('/entries/organs/new')">
          <i class="plus icon"></i> Novo Órgão
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="organs-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="organs-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="navToOrganForm" />

  </div>

</template>

<script>
  
  import OrganService from "@/services/organ-service"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "OrgansPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {       
        title: "Órgãos", 
        service: new OrganService(),
        attributes: ["id", "description", "defaultText"],
        fields: [          
          { prop: "description", label: "Descrição do Órgão" },           
          { prop: "defaultText", label: "Texto Padrão", render: (organ) => this.$truncateString(organ.defaultText, 170) },           
        ],
      }
    },

    methods: {

      navToOrganForm(data) {
        this.$router.push("/entries/organs/" + data.row.id)
      },
    },
  }

</script>
